﻿export class LookupProperty {
    name: string;
}

export class LookupPropertyString extends LookupProperty {
    value: string;
}

export class LookupPropertyDecimal extends LookupProperty {
    value: number;
}

export class LookupPropertyBoolean extends LookupProperty {
    value: boolean;
}

export class LookupPropertyDateTime extends LookupProperty {
    value: string;
}